import { render } from "./ShareOlt.vue?vue&type=template&id=220612ba&scoped=true"
import script from "./ShareOlt.vue?vue&type=script&lang=js"
export * from "./ShareOlt.vue?vue&type=script&lang=js"

import "./ShareOlt.vue?vue&type=style&index=0&id=220612ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220612ba"]])

export default __exports__